import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.less";
import iconShouye from "@/images/home/icon-shouye.svg";
import iconShouyeS from "@/images/home/icon-shouye-s.svg";
import iconhuagong from "@/images/home/icon-huagong.svg";
import iconhuagongS from "@/images/home/icon-huagong-s.svg";
import iconFuwu from "@/images/home/icon-fuwu.svg";
import iconFuwuS from "@/images/home/icon-fuwu-s.svg";
import iconBook from "@/images/home/icon-book.svg";
import iconBookS from "@/images/home/icon-book-s.svg";

// import { createFromIconfontCN } from "@ant-design/icons";

// const MyIcon = createFromIconfontCN({
//   scriptUrl: "//at.alicdn.com/t/c/font_4167130_06oqyb0sroy.js", // 在 iconfont.cn 上生成
// });

interface menuItem {
  key: string;
  label: string;
  path: string;
  iconType: string;
  img: string;
  imgS: string;
  pathKeyLsit: string[];
}

const menuList: menuItem[] = [
  {
    key: "home",
    label: "首页",
    path: "/home",
    iconType: "icon-shouye1",
    img: iconShouye,
    imgS: iconShouyeS,
    pathKeyLsit: ["/home"],
  },
  {
    key: "productCenter",
    label: "产品中心",
    path: "/good/list",
    iconType: "icon-huagong",
    img: iconhuagong,
    imgS: iconhuagongS,
    pathKeyLsit: ["/good"],
  },
  {
    key: "service",
    label: "服务中心",
    path: "/service",
    iconType: "icon-fuwuanli",
    img: iconFuwu,
    imgS: iconFuwuS,
    pathKeyLsit: ["/service", "/quickOrder"],
  },
  {
    key: "safetyGas",
    label: "安全用气",
    path: "/safetyGas",
    iconType: "icon-book",
    img: iconBook,
    imgS: iconBookS,
    pathKeyLsit: ["/safetyGas"],
  },
];

const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState("");

  useEffect(() => {
    const { pathname } = location;
    const beginIndex = menuList.findIndex(
      ({ pathKeyLsit }) =>
        pathKeyLsit.findIndex((item) => pathname.startsWith(item)) > -1
    );
    if (beginIndex > -1) {
      const { key } = menuList[beginIndex];
      setSelected(key);
    } else {
      setSelected("");
    }
  }, [location]);

  const goPage: (item: menuItem) => void = (item) => {
    navigate(item.path);
    setSelected(item.key);
  };

  return (
    <div className="mall-menu-wrapper">
      <div className="max-width">
        <div className="mall-menu">
          <ul>
            {menuList.map((item) => (
              <li
                className={selected === item.key ? "selected" : ""}
                key={item.key}
                onClick={() => goPage(item)}
              >
                {/* <MyIcon className="menu-icon shop-m" type={item.iconType} /> */}
                <img
                  className="shop-m"
                  src={selected === item.key ? item.imgS : item.img}
                  alt=""
                />
                <span className="shop-pc">{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
